import Zendesk from 'components/Zendesk'
import { AppModalProvider } from 'context/ModalProvider'
import NotificationProvider from 'context/NotificationProvider'
import ProfileProvider from 'context/ProfileProvider'
import SidebarProvider from 'context/SidebarProvider'
import PropTypes from 'prop-types'
import { ModalProvider } from 'react-modal-hook'
import { Navigate, Outlet, useParams, useRouteLoaderData } from 'react-router-dom'
import CoreUILayoutProvider from '../layout/CoreUILayoutProvider'
import SWRConfig from '../SWRConfig'
import ScrollToTop from './ScrollToTop'

function AppContainer({ header, children }) {
  const settings = useRouteLoaderData('root')
  const { locales } = settings
  const { lang } = useParams()

  if (locales?.length && !locales.includes(lang)) return <Navigate replace to="/404" />

  return (
    <>
      <ScrollToTop />
      <SWRConfig>
        <NotificationProvider>
          <ProfileProvider>
            <ModalProvider>
              <AppModalProvider>
                <CoreUILayoutProvider showHeader={header}>
                  <SidebarProvider>
                    <Zendesk />
                    <div id="filters-root" className="z-10"></div>
                    <Outlet />
                    {children ? children : null}
                  </SidebarProvider>
                </CoreUILayoutProvider>
              </AppModalProvider>
            </ModalProvider>
          </ProfileProvider>
        </NotificationProvider>
      </SWRConfig>
    </>
  )
}

AppContainer.defaultProps = {
  header: true,
}

AppContainer.propTypes = {
  header: PropTypes.bool,
  children: PropTypes.node,
}

export default AppContainer
